module.exports = new __parcel__URL__("aggregation.5c8ab7fd.png").toString();